import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import Footer from '@/components/feature/Footer';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'qinggan-gushi');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const activeCategory = categories.find((c) => c.slug === activeSlug);
  const categoryArticles = getArticlesByCategory(activeSlug);

  const categoryTitle = activeCategory?.name || '文章分类';
  const categoryDesc = activeCategory?.description || '';

  return (
    <>
      <SEOHead
        title={`${categoryTitle} - 文章分类`}
        description={categoryDesc}
        keywords={`女女${categoryTitle},${categoryTitle}故事,女女关系,女性情感`}
        canonicalUrl={`https://tazhijian.com/category/${activeSlug}`}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${categoryTitle} | 她之间`,
          url: `https://tazhijian.com/category/${activeSlug}`,
          description: categoryDesc,
          isPartOf: { '@type': 'WebSite', name: '她之间', url: 'https://tazhijian.com' },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://tazhijian.com' },
            { '@type': 'ListItem', position: 2, name: categoryTitle, item: `https://tazhijian.com/category/${activeSlug}` },
          ],
        }}
      />

      <Navbar />
      <main className="pt-16 md:pt-18">
        <Breadcrumb />

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {categoryTitle}
            </h1>
            <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{categoryDesc}</p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 pb-2">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center gap-2 overflow-x-auto pb-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`} />
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-6xl mx-auto">
            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-200 text-foreground-400">
                  <i className="ri-inbox-line text-2xl" />
                </div>
                <p className="text-foreground-500">该分类下暂无文章，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}